<template>
  <div class="home-page" @click="closeAllBox" @contextmenu="closeAllBox">
    <div class="app-container" :class="{ fullscreen: configStore.fullScreen }">
      <div class="navi-bar">
        <div class="navi-bar-box">
          <div class="top">
            <div class="avater" @click="showUserProfile">
              <head-image :name="mine.nickName" :size="42" :url="mine.headImageThumb">
              </head-image>
            </div>
            <div class="menu">
              <router-link class="link" v-bind:to="'/home/chat'">
                <div class="menu-item">
                  <span class="icon iconfont icon-chat"></span>
                  <div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
                </div>
              </router-link>
              <router-link class="link" v-bind:to="'/home/friend'">
                <div class="menu-item">
                  <span class="icon iconfont icon-friend"></span>
                  <div v-show="recvCount > 0" class="unread-text">{{ recvCount }}</div>
                </div>
              </router-link>
              <router-link class="link" v-bind:to="'/home/group'">
                <div class="menu-item">
                  <span class="icon iconfont icon-group" style="font-size: 28px"></span>
                </div>
              </router-link>
              <router-link class="link" v-bind:to="'/home/setting'">
                <div class="menu-item">
                  <span class="icon iconfont icon-setting" style="font-size: 20px"></span>
                </div>
              </router-link>
            </div>
          </div>

          <div class="bottom">
            <div v-if="!configStore.electronMode" class="bottom-item" @click="onSwtichFullScreen">
              <i class="el-icon-full-screen"></i>
            </div>
            <div class="bottom-item" @click="onExit()" title="退出">
              <span class="icon iconfont icon-exit"></span>
            </div>
<!--            <div class="bottom-item" @click="quitAndInstall()" title="下载更新">-->
<!--              <span class="icon iconfont icon-aixin"></span>-->
<!--              <div class="bubble-container">-->
<!--                <div v-if="downloadState === 2" class="speech-bubble">-->
<!--                  <div class="bubble-title">最新版本<strong style="color: red">{{ downloadProcess.version }}</strong>已下載完成-->
<!--                  </div>-->
<!--                  <div class="bubble-content" @click="quitAndInstall">-->
<!--                    <a style="cursor: pointer">重启安装</a>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div v-if="downloadState === 1" class="speech-bubble">-->
<!--                  <div class="bubble-title">正在下載({{ downloadProcess.speed }})......</div>-->
<!--                  <div class="bubble-content">-->
<!--                    <el-progress-->
<!--                        style="margin-top: 5px"-->
<!--                        :text-inside="true"-->
<!--                        :stroke-width="18"-->
<!--                        :percentage="downloadProcess.percent"-->
<!--                        status="exception"-->
<!--                    ></el-progress>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content-box">
        <router-view></router-view>
      </div>
      <user-info ref="userInfo"></user-info>
      <group-info ref="groupInfo"></group-info>
      <full-image ref="fullImage"></full-image>
      <rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
      <rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
      <user-profile-card ref="userProfileCard"></user-profile-card>
    </div>
  </div>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue';
import UserInfo from '../components/common/UserInfo.vue';
import GroupInfo from '../components/group/GroupInfo.vue';
import FullImage from '../components/common/FullImage.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';
import UserProfileCard from '../components/common/UserProfileCard.vue';
import {connect} from "@/api/wssocket";


export default {
  components: {
    HeadImage,
    UserInfo,
    GroupInfo,
    FullImage,
    RtcPrivateVideo,
    RtcPrivateAcceptor,
    RtcGroupVideo,
    UserProfileCard
  },
  data() {
    return {
      audio: false,
      lastPlayAudioTime: new Date().getTime() - 1000,
      reconnecting: false,
      notification: null,
      privateMessagesBuffer: [],
      groupMessagesBuffer: [],
      systemMessagesBuffer: [],
      interval:null,
      showUpdater: false,
      downloadProcess: {
        percent: 0,
        speed: 0,
        transferred: '1kb',
        total: '2M',
        version: ''
      },
      downloadState: 1 //状态：0-待下载；1-下载中；2-下载完成
    }
  },
  methods: {
    init() {
      this.$eventBus.$on('exit', () => {
        // 退出登陆
        this.onExit();
      });
      this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
        // 进入单人视频通话
        this.$refs.rtcPrivateVideo.open(rctInfo);
      });
      this.$eventBus.$on('openGroupVideo', (rctInfo) => {
        // 进入多人视频通话
        this.$refs.rtcGroupVideo.open(rctInfo);
      });
      this.$eventBus.$on('openUserInfo', (user, pos) => {
        // 打开用户卡片
        this.$refs.userInfo.open(user, pos);
      });
      this.$eventBus.$on('openGroupInfo', (group, pos) => {
        // 打开群卡片
        this.$refs.groupInfo.open(group, pos);
      });
      this.$eventBus.$on('openFullImage', imageData => {
        // 图片大图
        this.$refs.fullImage.open(imageData);
      });
      this.configStore.setAppInit(false)
      this.loadStore().then(() => {
        // ws初始化
        this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
        this.$wsApi.onConnect(() => {
          if (this.reconnecting) {
            this.onReconnectWs();
          } else {
            // 加载离线消息
            this.pullOfflineMessage();
            this.configStore.setAppInit(true);
          }
        });
        this.$wsApi.onMessage((cmd, msgInfo) => {
          console.log("home.收到消息:", cmd, msgInfo)
          if (cmd == 2) {
            // 关闭ws
            this.$wsApi.close(3000)
            // 异地登录，强制下线
            this.$alert("您已在其他地方登录，将被强制下线", "强制下线通知", {
              confirmButtonText: '确定',
              callback: action => {
                this.onExit();
              }
            });
          } else if (cmd == 3) {
            if (!this.configStore.appInit || this.chatStore.loading) {
              // 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
              this.privateMessagesBuffer.push(msgInfo);
            } else {
              // 插入私聊消息
              this.handlePrivateMessage(msgInfo);
            }
          } else if (cmd == 4) {
            if (!this.configStore.appInit || this.chatStore.loading) {
              // 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
              console.log("消息进入缓存区:", msgInfo)
              this.groupMessagesBuffer.push(msgInfo);
            } else {
              // 插入群聊消息
              this.handleGroupMessage(msgInfo);
            }
          } else if (cmd == 5) {
            if (!this.configStore.appInit || this.chatStore.loading) {
              // 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
              this.systemMessagesBuffer.push(msgInfo);
            } else {
              // 处理系统消息
              this.handleSystemMessage(msgInfo);
            }
          }
        });
        this.$wsApi.onClose(e => {
          console.log(e);
          if (e.code != 3000) {
            // 断线重连
            this.reconnectWs();
            this.configStore.setAppInit(false)
          }
        });
      }).catch(e => {
        console.log(e)
        this.$alert('loadStore初始化失败\n错误: ' + (e.message || JSON.stringify(e)), '[PATH-7A] 初始化失败触发退出');
        this.$message.error("初始化失败");
        this.onExit();
      })
    },
    reconnectWs() {
      // 记录标志
      this.reconnecting = true;
      // 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
      this.userStore.loadUser().then(() => {
        // 断线重连
        this.$message.error("连接断开，正在尝试重新连接...");
        this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem(
            "accessToken"));
      }).catch(() => {
        // 10s后重试
        setTimeout(() => this.reconnectWs(), 10000)
      })
    },
    // fix #116: 系统从锁屏/休眠恢复时调用。关闭旧 WS（OS-level TCP 此时已死），等待 2s
    // 给网络栈恢复时间，再走标准 reconnectWs 流程，避免在网络未就绪时立即拉离线消息触发 PATH-7B
    onSystemResume(info) {
      console.log('[PC-POWER] system-resume:', info)
      try { this.$wsApi.close() } catch (e) { /* ignore */ }
      this.reconnecting = true
      setTimeout(() => {
        if (this.reconnecting) {
          this.reconnectWs()
        }
      }, 2000)
    },
    setupPowerMonitorListener() {
      if (window.electronAPI && window.electronAPI.receive) {
        window.electronAPI.receive('system-resume', (info) => this.onSystemResume(info))
      }
    },
    onReconnectWs() {
      // 重连成功
      this.reconnecting = false;
      // 重新加载群和好友
      const promises = [];
      promises.push(this.friendStore.loadFriend());
      promises.push(this.groupStore.loadGroup());
      Promise.all(promises).then(() => {
        // 加载离线消息
        this.pullOfflineMessage();
        this.configStore.setAppInit(true);
        this.$message.success("重新连接成功");
      }).catch((e) => {
        this.$alert('重连后加载好友/群组失败\n错误: ' + (e.message || JSON.stringify(e)), '[PATH-6] 重连恢复失败触发退出');
        this.$message.error("初始化失败");
        this.onExit();
      })
    },
    loadStore() {
      return this.userStore.loadUser().then(() => {
        const promises = [];
        promises.push(this.friendStore.loadFriend());
        promises.push(this.groupStore.loadGroup());
        promises.push(this.chatStore.loadChat());
        promises.push(this.configStore.loadConfig());
        promises.push(this.mediaCacheStore.init());
        return Promise.all(promises);
      })
    },
    unloadStore() {
      this.friendStore.clear();
      this.groupStore.clear();
      this.chatStore.clear();
      this.userStore.clear();
    },
    pullOfflineMessage(retryCount = 0) {
      const MAX_RETRY = 3;
      let timeStamp = new Date().getTime();
      this.chatStore.setLoading(true);
      const promises = [];
      promises.push(this.pullPrivateOfflineMessage(this.chatStore.privateMsgMaxId));
      promises.push(this.pullGroupOfflineMessage(this.chatStore.groupMsgMaxId));
      promises.push(this.pullSystemOfflineMessage(this.chatStore.systemMsgMaxSeqNo));
      Promise.all(promises).then(messages => {
        // 处理离线消息
        messages[0].forEach(m => this.handlePrivateMessage(m));
        messages[1].forEach(m => this.handleGroupMessage(m));
        messages[2].forEach(m => this.handleSystemMessage(m));
        // 处理缓冲区收到的实时消息
        this.privateMessagesBuffer.forEach(m => this.handlePrivateMessage(m));
        this.groupMessagesBuffer.forEach(m => this.handleGroupMessage(m));
        this.systemMessagesBuffer.forEach(m => this.handleSystemMessage(m));
        // 清空缓冲区
        this.privateMessagesBuffer = [];
        this.groupMessagesBuffer = [];
        this.systemMessagesBuffer = [];
        // 关闭加载离线标记
        this.chatStore.setLoading(false);
        // 刷新会话
        this.chatStore.refreshChats();
        // 扫描所有会话的视频消息补启动预热（覆盖本地缓存加载的历史消息）
        try { this.videoPrewarmStore && this.videoPrewarmStore.prewarmFromChatStore(this.chatStore) } catch (e) { /* ignore */ }
        // 打印耗时
        let size = messages[0].length + messages[1].length + messages[2].length;
        let time = new Date().getTime() - timeStamp;
        console.log("加载离线消息耗时:", time, ",消息数量:", size)
      }).catch((e) => {
        console.log(e)
        if (retryCount < MAX_RETRY) {
          let delay = (retryCount + 1) * 3000;
          console.log(`离线消息加载失败，${delay / 1000}秒后第${retryCount + 1}次重试...`)
          this.$message.warning(`离线消息加载失败，正在重试(${retryCount + 1}/${MAX_RETRY})...`);
          setTimeout(() => this.pullOfflineMessage(retryCount + 1), delay);
        } else {
          this.chatStore.setLoading(false);
          this.$alert(
              '拉取离线消息失败\n错误: ' + (e.message || JSON.stringify(e)),
              '[PATH-7B] 离线消息加载失败',
              {
                confirmButtonText: '重试',
                cancelButtonText: '退出',
                showCancelButton: true,
                callback: (action) => {
                  if (action === 'confirm') {
                    this.pullOfflineMessage(0);
                  } else {
                    this.onExit();
                  }
                }
              }
          );
        }
      })
    },
    pullPrivateOfflineMessage(minId) {
      return this.$http({
        url: "/message/private/loadOfflineMessage?minId=" + minId,
        method: 'GET'
      })
    },
    pullGroupOfflineMessage(minId) {
      return this.$http({
        url: "/message/group/loadOfflineMessage?minId=" + minId,
        method: 'GET'
      })
    },
    pullSystemOfflineMessage(minSeqNo) {
      return this.$http({
        url: "/message/system/loadOfflineMessage?minSeqNo=" + minSeqNo,
        method: 'GET'
      })
    },
    handlePrivateMessage(msg) {
      // 视频消息：WebSocket 一到立即预热 m3u8 + 静默下载
      if (msg && msg.type === this.$enums.MESSAGE_TYPE.VIDEO && msg.id) {
        try { this.videoPrewarmStore && this.videoPrewarmStore.prewarm(msg) } catch (e) { /* ignore */ }
      }
      // 标记这条消息是不是自己发的
      msg.selfSend = msg.sendId == this.mine.id;
      // 好友id
      let friendId = msg.selfSend ? msg.recvId : msg.sendId;
      // console.log("handlePrivateMessage.处理私聊消息:", msg,friendId,msg.status)
      // 会话信息
      let chatInfo = {
        type: 'PRIVATE',
        targetId: friendId
      }
      // 消息已读处理，清空已读数量
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        this.chatStore.resetUnreadCount(chatInfo)
        return;
      }
      // 消息回执处理,改消息状态为已读
      if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
        this.chatStore.readedMessage({
          friendId: msg.sendId
        })
        return;
      }
      // 消息撤回
      if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
        this.chatStore.recallMessage(msg, chatInfo)
        return;
      }
      // 好友申请
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPLY) {
        this.friendStore.addRequest(JSON.parse(msg.content))
        return;
      }
      // 好友申请被同意、拒绝、撤回
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPROVE
          || msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_REJECT
          || msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_RECALL) {
        // console.log("handlePrivateMessage.处理私聊消息.removeRequest:", msg,friendId,msg.status)
        this.friendStore.removeRequest(JSON.parse(msg.content).id)
        return;
      }
      // 新增好友
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
        this.friendStore.addFriend(JSON.parse(msg.content));
        return;
      }
      // 删除好友
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
        this.friendStore.removeFriend(friendId);
        return;
      }
      // 好友在线状态
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
        this.friendStore.updateOnlineStatus(JSON.parse(msg.content));
        return;
      }
      // 对好友设置免打扰
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DND) {
        this.friendStore.setDnd(friendId, JSON.parse(msg.content));
        this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
        return;
      }
      // 对好友进行会话置顶
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_TOP) {
        this.friendStore.setTop(friendId, JSON.parse(msg.content));
        this.chatStore.setTop(chatInfo, JSON.parse(msg.content));
        return;
      }
      // 单人webrtc 信令
      if (this.$msgType.isRtcPrivate(msg.type)) {
        this.$refs.rtcPrivateVideo.onRTCMessage(msg)
        return;
      }
      // 消息插入
      if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
        let friend = this.loadFriendInfo(friendId);
        // console.log("handlePrivateMessage.处理私聊消息.friend:", friend)
        this.insertPrivateMessage(friend, msg);
      }
    },
    insertPrivateMessage(friend, msg) {
      let chatInfo = {
        type: 'PRIVATE',
        targetId: friend.id,
        showName: friend.showNickName,
        headImage: friend.headImage,
        companyName: friend.companyName,
        isDnd: friend.isDnd,
        isTop: friend.isTop
      };
      // 打开会话
      this.chatStore.openChat(chatInfo);
      // 插入消息
      this.chatStore.insertMessage(msg, chatInfo);
      if (!friend.isDnd && !this.chatStore.loading &&
          !msg.selfSend && this.$msgType.isNormal(msg.type)
          && msg.status != this.$enums.MESSAGE_STATUS.READED) {
        // 播放提示音
        this.playAudioTip();
        // 消息提醒
        let chat = this.chatStore.findChat(chatInfo);
        this.showNotification(chat, friend.showNickName, friend.headImage)
      }
    },
    handleGroupMessage(msg) {
      console.log("handleGroupMessage.处理群消息:", msg)
      // 视频消息：WebSocket 一到立即预热 m3u8 + 静默下载
      if (msg && msg.type === this.$enums.MESSAGE_TYPE.VIDEO && msg.id) {
        try { this.videoPrewarmStore && this.videoPrewarmStore.prewarm(msg) } catch (e) { /* ignore */ }
      }
      // 标记这条消息是不是自己发的
      msg.selfSend = msg.sendId == this.mine.id;
      // 发送用户昵称优先显示好友备注的名字
      if (msg.sendId && msg.sendNickName) {
        let f = this.friendStore.findFriend(msg.sendId);
        if (f && !f.deleted && f.remarkNickName) {
          msg.sendNickName = f.remarkNickName;
        }
      }
      let chatInfo = {
        type: 'GROUP',
        targetId: msg.groupId
      }
      // 消息已读处理
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        // 我已读对方的消息，清空已读数量
        this.chatStore.resetUnreadCount(chatInfo)
        this.chatStore.resetAtMessage(chatInfo)
        return;
      }
      // 消息回执处理
      if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
        // 更新消息已读人数
        let msgInfo = {
          id: msg.id,
          groupId: msg.groupId,
          readedCount: msg.readedCount,
          receiptOk: msg.receiptOk
        };
        this.chatStore.updateMessage(msgInfo, chatInfo)
        return;
      }
      // 消息撤回
      if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
        this.chatStore.recallMessage(msg, chatInfo)
        return;
      }
      // 新增群
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
        this.groupStore.addGroup(JSON.parse(msg.content));
        return;
      }
      // 删除群
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
        this.groupStore.removeGroup(msg.groupId);
        return;
      }
      // 群消息置顶
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP_MESSAGE) {
        let topMessage = msg.content ? JSON.parse(msg.content) : null;
        this.groupStore.updateTopMessage(msg.groupId, topMessage);
        return;
      }
      // 对群设置免打扰
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DND) {
        this.groupStore.setDnd(msg.groupId, JSON.parse(msg.content));
        this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
        return;
      }
      // 群全体禁言
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_ALL_MUTED) {
        this.groupStore.setAllMuted(msg.groupId, JSON.parse(msg.content));
        return;
      }
      // 被禁言
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_MEMBER_MUTED) {
        this.groupStore.setMuted(msg.groupId, JSON.parse(msg.content));
        return;
      }
      // 对好友进行会话置顶
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP) {
        this.groupStore.setTop(msg.groupId, JSON.parse(msg.content));
        this.chatStore.setTop(chatInfo, JSON.parse(msg.content));
        return;
      }
      // 群视频信令
      if (this.$msgType.isRtcGroup(msg.type)) {
        this.$nextTick(() => {
          this.$refs.rtcGroupVideo.onRTCMessage(msg);
        })
        return;
      }
      // 插入群聊消息
      if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
        let group = this.loadGroupInfo(msg.groupId);
        this.insertGroupMessage(group, msg);
      }
    },
    insertGroupMessage(group, msg) {
      let chatInfo = {
        type: 'GROUP',
        targetId: group.id,
        showName: group.showGroupName,
        headImage: group.headImageThumb,
        isDnd: group.isDnd,
        isTop: group.isTop
      };
      // 打开会话
      this.chatStore.openChat(chatInfo);
      // 插入消息
      this.chatStore.insertMessage(msg, chatInfo);
      // 提示音和消息提醒
      if (!group.isDnd && !msg.selfSend && !this.chatStore.loading && this.$msgType.isNormal(msg.type)
          && msg.status != this.$enums.MESSAGE_STATUS.READED) {
        // 播放提示音
        this.playAudioTip();
        // 消息提醒
        let chat = this.chatStore.findChat(chatInfo);
        this.showNotification(chat, group.showGroupName, group.headImageThumb)
      }
    },
    handleSystemMessage(msg) {
      // HLS 转码就绪：后端异步转码完成后推送，把 m3u8Url 注入到对应消息的 content
      console.log('[VIDEO_HLS] ← 收到系统消息 type:', msg.type, 'raw:', msg)
      if (msg.type === 'HLS_READY') {
        let messageId = msg.messageId || (msg.data && msg.data.messageId);
        let m3u8Url = msg.m3u8Url || (msg.data && msg.data.m3u8Url);
        console.log('[VIDEO_HLS] ▶ HLS_READY 推送 messageId:', messageId, 'm3u8Url:', m3u8Url)
        if (messageId && m3u8Url) {
          this.chatStore.patchMessageContent(messageId, { m3u8Url, m3u8Status: 'completed' });
          console.log('[VIDEO_HLS] ✓ HLS_READY 已注入 content')
        } else {
          console.warn('[VIDEO_HLS] ✗ HLS_READY 缺少 messageId 或 m3u8Url, 忽略')
        }
        return;
      }
      // 消息已读处理，清空已读数量
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        this.chatStore.resetUnreadCount({
          type: 'SYSTEM',
          targetId: 0
        })
        return;
      }
      // 用户被封禁
      if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
        this.$wsApi.close(3000);
        this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
          confirmButtonText: '确定',
          callback: action => {
            this.onExit();
          }
        });
        return;
      }
      // 用户账户注销
      if (msg.type == this.$enums.MESSAGE_TYPE.USER_UNREG) {
        this.$wsApi.close(3000);
        this.$alert("您的账号已注销", {
          confirmButtonText: '确定',
          callback: action => {
            this.onExit();
          }
        });
        return;
      }
      // 插入消息
      this.insertSystemMessage(msg);
    },
    insertSystemMessage(msg) {
      let headImage = require('@/assets/image/chat_system.png')
      let chatInfo = {
        type: 'SYSTEM',
        targetId: 0,
        showName: "系统通知",
        headImage: headImage
      };
      // 打开会话
      this.chatStore.openChat(chatInfo);
      // 插入消息
      this.chatStore.insertMessage(msg, chatInfo);
    },
    onSwtichFullScreen() {
      this.configStore.setFullScreen(!this.configStore.fullScreen);
    },
    onExit() {
      this.unloadStore();
      this.configStore.setAppInit(false);
      this.$wsApi.close(3000);
      sessionStorage.removeItem("accessToken");
      localStorage.setItem("isAutoLogin", false)
      this.$router.push("/login");
    },
    closeAllBox() {
      this.$refs.groupInfo.close();
      this.$refs.userInfo.close();
    },
    playAudioTip() {
      // 播放间隔必须大于1s
      let interval = new Date().getTime() - this.lastPlayAudioTime;
      if (this.mine.isAudioTip && interval > 1000) {
        if (!this.audio) {
          this.audio = new Audio();
          this.audio.src = require(`@/assets/audio/tip.mp3`);
        }
        this.lastPlayAudioTime = new Date().getTime();
        this.audio.play();
      }
    },
    showNotification(chat, title, icon) {
      // 消息提醒
      if (window.electronAPI) {
        // 当窗口失去焦点，则弹出通知消息
        window.electronAPI.invoke("isFocused").then(foucus => {
          if (!foucus) {
            // 任务栏闪烁提醒
            window.electronAPI.sendEvent('flash-frame');
            if (window.Notification) {
              this.notification && this.notification.close();
              let iconPath = icon ? icon : 'logo.png';
              this.notification = new Notification(title, {
                body: chat.lastContent,
                icon: iconPath
              })
              // 点击通知消息，激活聊天会话
              this.notification.onclick = () => {
                this.chatStore.openChat(chat);
                this.chatStore.setActiveChat(chat);
                this.$router.push("/home/chat");
                // 唤醒在后台的客户端
                window.electronAPI.sendEvent("show");
              }
            }
          }
        })
      }
    },
    loadFriendInfo(id) {
      let friend = this.friendStore.findFriend(id);
      if (!friend) {
        friend = {
          id: id,
          showNickName: "未知用户",
          headImage: ""
        }
      }
      return friend;
    },
    loadGroupInfo(id) {
      let group = this.groupStore.findGroup(id);
      if (!group) {
        group = {
          id: id,
          showGroupName: "未知群聊",
          headImageThumb: ""
        }
      }
      return group;
    },
    showUserProfile() {
      this.$refs.userProfileCard.open();
    },
    setupAutoUpdaterListeners() {
      if (window.electronAPI) {
        // 下载完成
        window.electronAPI.receive('autoUpdater-downloaded', (event, process) => {
          console.log('autoUpdater-downloaded--下載完成')
          this.showUpdater = true
          this.downloadState = 2
        })
        //下載進度
        window.electronAPI.receive('autoUpdater-progress', (event, process) => {
          console.log('autoUpdater-progress', process)
          this.downloadState = 1
          this.showUpdater = true
          if (process.transferred >= 1024 * 1024) {
            process.transferred = (process.transferred / 1024 / 1024).toFixed(2) + 'M'
          } else {
            process.transferred = (process.transferred / 1024).toFixed(2) + 'K'
          }
          if (process.total >= 1024 * 1024) {
            process.total = (process.total / 1024 / 1024).toFixed(2) + 'M'
          } else {
            process.total = (process.total / 1024).toFixed(2) + 'K'
          }
          if (process.bytesPerSecond >= 1024 * 1024) {
            process.speed = (process.bytesPerSecond / 1024 / 1024).toFixed(2) + 'M/s'
          } else if (process.bytesPerSecond >= 1024) {
            process.speed = (process.bytesPerSecond / 1024).toFixed(2) + 'K/s'
          } else {
            process.speed = process.bytesPerSecond + 'B/s'
          }
          process.percent = parseFloat(process.percent.toFixed(2))
          this.downloadProcess = process
        })
      }

    },
    // 重启安装应用
    quitAndInstall() {
      if (window.electronAPI) {
        window.electronAPI.sendEvent('restart-app', 'install')
      }
    },
    checkUpdate(){
      if (this.downloadProcess.percent === 0) {
        window.electronAPI.sendEvent('monitor-update-system')
      }
    },
    intervalCheck(){
      let _this=this;
      this.interval = setInterval(function () { // 延迟5秒重连  避免过多次过频繁请求重连
       // this.checkUpdate()
        if (window.electronAPI) {
          if (_this.downloadProcess.percent === 0&&_this.downloadState===0) {
            window.electronAPI.sendEvent('monitor-update-system')
          }
        }
      }, 5000);
    }
  },
  computed: {
    mine() {
      return this.userStore.userInfo;
    },
    unreadCount() {
      let unreadCount = 0;
      let chats = this.chatStore.chats;
      chats.forEach((chat) => {
        if (!chat.delete && !chat.isDnd) {
          unreadCount += chat.unreadCount
        }
      });
      return unreadCount;
    },
    recvCount() {
      let requests = this.friendStore.requests;
      return requests.filter((req) => req.recvId == this.mine.id).length;
    }
  },
  watch: {
    unreadCount: {
      handler(newCount, oldCount) {
        let tip = newCount > 0 ? `${newCount}条未读` : "";
        this.$elm.setTitleTip(tip);
      },
      immediate: true
    }
  },
  mounted() {
    this.$wsApi.close();
    this.init();
    this.intervalCheck();
    // 添加 Electron 更新监听
    this.setupAutoUpdaterListeners();
    // fix #116: 监听系统电源事件，锁屏/休眠恢复时延迟重连 WS
    this.setupPowerMonitorListener();
    // 修改electron窗口尺寸
    window.electronAPI && window.electronAPI.sendEvent('resize', {
      width: 970,
      height: 700,
      maximizable: true
    })
    window.electronAPI && window.electronAPI.sendEvent('center')
  },
  unmounted() {
    this.$wsApi.close();
    clearTimeout(this.interval);
  }
}
</script>

<style scoped lang="scss">
.home-page {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  background: var(--im-color-primary-light-9);

  .app-container {
    width: 62vw;
    height: 80vh;
    display: flex;
    min-height: 700px;
    min-width: 970px;
    position: absolute;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: var(--im-box-shadow-dark);
    transition: 0.2s;

    &.fullscreen {
      transition: 0.2s;
      width: 100vw;
      height: 100vh;
    }
  }

  .navi-bar {
    --icon-font-size: 22px;
    --width: 70px;
    width: var(--width);
    background: #1c2438;
    padding-top: 25px;
    position: relative;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);

    // 添加顶部装饰线
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, var(--im-color-primary) 0%, var(--im-color-primary-light-3) 50%, var(--im-color-primary) 100%);
    }

    .navi-bar-box {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .bottom {
        margin-bottom: 25px;
      }
    }

    .avater {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;

      // 为头像添加容器样式
      :deep(.head-image) {
        //border: 3px solid rgba(255, 255, 255, 0.2);
        //border-radius: 5rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;

        &:hover {
          border-color: rgba(255, 255, 255, 0.4);
          transform: scale(1.05);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        }
      }
    }

    .menu {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
      margin-top: 25px;
      gap: 8px;

      .link {
        text-decoration: none;
        display: flex;
        justify-content: center;
      }

      .router-link-active .menu-item {
        color: white;
        background: linear-gradient(135deg, var(--im-color-primary-light-2) 0%, var(--im-color-primary) 100%);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        transform: translateX(2px);

        &::before {
          opacity: 1;
          transform: scale(1);
        }
      }

      .link:not(.router-link-active) .menu-item:hover {
        background: linear-gradient(135deg, var(--im-color-primary) 0%, var(--im-color-primary-light-2) 100%);
        transform: scale(1.08) translateX(2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
        color: white;
      }

      .menu-item {
        position: relative;
        color: rgba(255, 255, 255, 0.8);
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        border-radius: 12px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;

        // 添加左侧指示条
        &::before {
          content: '';
          position: absolute;
          left: -5px;
          width: 3px;
          height: 20px;
          background: white;
          border-radius: 2px;
          opacity: 0;
          transition: all 0.3s ease;
        }

        .icon {
          font-size: var(--icon-font-size);
          transition: all 0.3s ease;
        }

        .unread-text {
          position: absolute;
          background: var(--im-color-danger);
          left: 32px;
          top: 3px;
          color: white;
          border-radius: 10px;
          padding: 1px 6px;
          font-size: 10px;
          font-weight: 600;
          text-align: center;
          white-space: nowrap;
          border: 1px solid rgba(255, 255, 255, 0.9);
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
          min-width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }
      }
    }

    .bottom-item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 45px;
      width: 100%;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.7);
      font-size: var(--icon-font-size);
      border-radius: 8px;
      margin: 4px 0;
      transition: all 0.3s ease;
      position: relative;

      .icon {
        font-size: var(--icon-font-size);
        transition: all 0.3s ease;
      }

      &:hover {
        color: white;
        background: rgba(255, 255, 255, 0.1);
        transform: scale(1.05);

        .icon {
          transform: scale(1.1);
        }
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }

  .content-box {
    flex: 1;
    padding: 0;
    background: var(--im-background);
    text-align: center;
  }

  /* 气泡对话框样式 */

  .bubble-container {
    position: fixed;
    bottom: 0px;
    left: 70px;
    z-index: 1000;
    width: 200px;
    transition: transform 0.3s ease;
  }

  /* 防止气泡本身触发hover，只让容器触发 */
  .bubble-container:hover {
    transform: translateY(-5px);
  }

  /* 关键修复：让气泡内容不干扰鼠标事件 */
  .speech-bubble {
    position: relative;
    background-color: #ffffff;
    color: black;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    pointer-events: none; /* 防止气泡内部元素干扰hover */
  }

  /* 但需要让气泡内的可点击元素恢复鼠标事件 */
  .bubble-content,
  .bubble-content a,
  .bubble-content * {
    pointer-events: auto; /* 恢复可点击元素的鼠标事件 */
  }

  /* 气泡三角形 */
  .speech-bubble::after {
    content: '';
    position: absolute;
    left: -10px;
    top: 35%;
    border-width: 10px 10px 10px 0;
    border-style: solid;
    border-color: transparent #3498db transparent transparent;
    pointer-events: none; /* 三角形也不干扰 */
  }

}
</style>
